/* T6 November hero (C-3053, VZ). Ported from Suzy's design reference banner.html.
   Changes from the reference, from VZ's review: the countdown starts exactly at the section's countdown_start; the desktop spotlight
   also stops under reduced motion, Save-Data or refused autoplay; a pause/play button stops all moving media (WCAG 2.2.2). */
(function () {
  function init(root) {
    if (root.dataset.ntnInit) return;
    root.dataset.ntnInit = '1';
    var END = Date.parse(root.dataset.offerEnd);
    var LIVE_FROM = Date.parse(root.dataset.countdownStart);
    var START = Date.parse(root.dataset.offerStart);
    var q = new URLSearchParams(location.search).get('now');
    var off = q && !isNaN(Date.parse(q)) ? Date.parse(q) - Date.now() : 0;
    var nowMs = function () { return Date.now() + off; };
    var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };

    /* November layer: on between offer_start and offer_end in the visitor's browser too, so a cached page cannot show it late. */
    var offDone = false;
    function novOff() {
      if (offDone) return; offDone = true;
      root.classList.add('nov-off');
      $$('.now[data-base]').forEach(function (n) { n.textContent = n.dataset.base; });
      $$('[data-base-label]').forEach(function (n) { n.textContent = n.dataset.baseLabel; });
    }
    var ends = $$('[data-ends]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = nowMs(), left = END - now;
      if (!root.classList.contains('has-nov')) return;
      if (now < START || left <= 0) { ends.forEach(function (e) { e.className = 'ends'; e.textContent = ''; }); novOff(); return; }
      ends.forEach(function (e) {
        if (now < LIVE_FROM) { e.className = 'ends'; e.textContent = ''; return; }
        var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4), s = Math.floor(left % 6e4 / 1e3);
        e.className = 'ends live';
        e.textContent = 'Ends in ' + (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      });
    }
    tick(); setInterval(tick, 1000);

    /* Motion: posters only under reduced motion or Save-Data; the pause button stops everything. */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var save = !!(navigator.connection && navigator.connection.saveData);
    var still = reduce || save;
    var mobile = window.matchMedia('(max-width:820px)').matches;
    var paused = still;
    var timers = [];
    function arm(v) { if (!v.src && v.dataset.src) v.src = v.dataset.src; }
    function playV(v) { var p = v.play(); if (p && p.catch) p.catch(function () { stopAll(); }); }
    function stopAll() {
      paused = true; root.classList.add('paused');
      timers.forEach(clearInterval); timers = [];
      $$('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      var box = root.querySelector('.cards'); if (box) box.classList.remove('cycling');
      var btn = root.querySelector('.pause'); if (btn) { btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', btn.dataset.playLabel); }
    }

    var cards = $$('.card'), box = root.querySelector('.cards'), i = 0;
    var vids = $$('.mstage video'), lab = root.querySelector('.mplace'), txt = root.querySelector('.mplace .txt'), j = 0;
    var names = vids.map(function (v) { return v.dataset.label || ''; });

    function stepCards() { cards.forEach(function (c, k) { c.classList.toggle('on', k === i); }); i = (i + 1) % cards.length; }
    function showClip() {
      var nx = vids[(j + 1) % vids.length]; arm(nx); nx.preload = 'auto';
      vids.forEach(function (v, k) {
        if (k === j) { arm(v); v.currentTime = 0; v.classList.remove('on'); void v.offsetWidth; v.classList.add('on'); playV(v); }
        else v.classList.remove('on');
      });
      if (txt) { txt.textContent = names[j]; txt.style.animation = 'none'; void txt.offsetWidth; txt.style.animation = ''; }
      if (lab) { lab.classList.remove('run'); void lab.offsetWidth; lab.classList.add('run'); }
      j = (j + 1) % vids.length;
    }
    function startAll() {
      paused = false; root.classList.remove('paused');
      var btn = root.querySelector('.pause'); if (btn) { btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', btn.dataset.pauseLabel); }
      if (mobile) {
        if (vids.length) { showClip(); timers.push(setInterval(showClip, 3400)); }
      } else {
        $$('.card video').forEach(function (v) { arm(v); v.preload = 'auto'; playV(v); });
        if (box && cards.length) {
          /* the spotlight begins after the intro animation (3.6 s after load), as in the reference */
          var wait = Math.max(0, 3600 - (performance.now() - (window.__ntnLoadAt || 0)));
          var t = setTimeout(function () { if (paused) return; box.classList.add('cycling'); stepCards(); timers.push(setInterval(stepCards, 3200)); }, wait);
          timers.push(t);
        }
      }
    }

    if (still) {
      root.classList.add('paused');
      if (mobile && vids[0] && txt) txt.textContent = names[0];
    } else if (mobile) {
      startAll();
    } else {
      var go = function () { window.__ntnLoadAt = performance.now(); if (!paused) startAll(); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
    }
    var btn = root.querySelector('.pause');
    if (btn) btn.addEventListener('click', function () { if (paused) startAll(); else stopAll(); });
  }
  function boot() { [].slice.call(document.querySelectorAll('.nt-hero-nov')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
